import { useEffect, useState } from 'react';
import {
    ContourRedoRequestedEvent,
    ContourUndoRequestedEvent,
    domainEventBus,
} from '~/domain/events';
import { getContourUndoService } from '~/domain/ServiceContainer';
import { ContourOperationResult } from '~/domain/undo';

const publishContourEvent = (
    result: ContourOperationResult,
    EventClass:
        | typeof ContourUndoRequestedEvent
        | typeof ContourRedoRequestedEvent
) => {
    const event = new EventClass(
        result.roiNumber,
        result.compressedPixels,
        result.grid
    );
    domainEventBus.publish(event).catch((error) => {
        console.error('Failed to publish contour event:', error);
    });
};

export const useUndoRedo = (roiNumber: number) => {
    const [state, setState] = useState({
        canUndo: false,
        canRedo: false,
    });

    useEffect(() => {
        const contourUndoService = getContourUndoService();
        const updateState = () => {
            setState({
                canUndo: contourUndoService.canUndo(roiNumber),
                canRedo: contourUndoService.canRedo(roiNumber),
            });
        };
        const subscription = contourUndoService.subscribe(updateState);
        return subscription.unsubscribe;
    }, [roiNumber]);

    const undo = () => {
        const contourUndoService = getContourUndoService();
        const result = contourUndoService.undo(roiNumber);
        if (result) {
            publishContourEvent(result, ContourUndoRequestedEvent);
        }
        return result;
    };

    const redo = () => {
        const contourUndoService = getContourUndoService();
        const result = contourUndoService.redo(roiNumber);
        if (result) {
            publishContourEvent(result, ContourRedoRequestedEvent);
        }
        return result;
    };

    return {
        canUndo: state.canUndo,
        canRedo: state.canRedo,
        undo,
        redo,
    };
};
